import { render } from "./ResourcesGroup2.vue?vue&type=template&id=4d93561e"
import script from "./ResourcesGroup2.vue?vue&type=script&lang=js"
export * from "./ResourcesGroup2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__